module.exports = __webpack_public_path__ + "static/media/_Bio MORRIS KAHN.270040f9.DOCX";